export default "__VITE_ASSET__7c77ce0a__"